// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-video[data-v-4255a8e0] {
  width: 100%;
  height: 100%;
  background: #000;
}
.video-cover[data-v-4255a8e0] {
  object-fit: cover;
}
.video-flipped[data-v-4255a8e0] {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/video-engine/components/video-call/shared/MediaTrackRenderer.vue","webpack://./MediaTrackRenderer.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;ACDF;ADIA;EACE,iBAAA;ACDF;ADIA;EACE,qBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.media-video {\n  width: 100%;\n  height: 100%;\n  background: #000;\n}\n\n.video-cover {\n  object-fit: cover;\n}\n\n.video-flipped {\n  transform: scaleX(-1);\n}\n",".media-video {\n  width: 100%;\n  height: 100%;\n  background: #000;\n}\n\n.video-cover {\n  object-fit: cover;\n}\n\n.video-flipped {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
